import { parseDate } from '@sharedHelpers/formatDate';
import { orderStatusMap } from '@entities/Order/module/types/userOrdersSchema';
import { useAppSelector } from '@redux/hooks';
import { getUserProfileData } from '@entities/User';
import { getRecordService } from '@entities/Services';
import { getUserDiscountCards } from '@entities/Discount';
import { getListOx } from '@entities/Storage';
import { getUserAutoList } from '@entities/Auto';
import { getListsOrder } from '@entities/Order';

export const useJivoSiteHandlers = (): { handlerSendUserData: () => void } => {
  const user = useAppSelector(getUserProfileData);
  const record = useAppSelector(getRecordService);
  const card = useAppSelector(getUserDiscountCards);
  const ox = useAppSelector(getListOx);
  const cars = useAppSelector(getUserAutoList);
  const orders = useAppSelector(getListsOrder);

  const createContentString = (prefix, items, formatter) => {
    return items.length ? `${prefix} ${items.map(formatter).join(' ')}` : '';
  };

  const handlerSendUserData = () => {
    try {
      if (!user) {
        return;
      }

      const thirtyDaysAgo = new Date().getTime() - 1000 * 60 * 60 * 24 * 30;
      const recentOrders = orders.filter(order => parseDate(order.orderDate).getTime() >= thirtyDaysAgo);

      const userInfo = {
        name: `${user.surName} ${user.firstName} ${user.lastName}`,
        email: user.email,
        phone: user.phone.toString(),
        description: 'информация авторизованного пользователя',
      };
      window.jivo_api.setContactInfo(userInfo);

      const arrayInfoData = [];

      if (record[0]) {
        arrayInfoData.push({
          title: 'Активная запись на услугу',
          content: `Тип услуги: шиномонтаж, ${record[0]?.shopName} ${record[0]?.date?.datetime}, 
          Машина: ${record[0].carName}, гос. номер - ${record[0].gtd}`,
        });
      }

      const oxContent = createContentString('номер партии:', ox, x => x?.partyCode);
      if (oxContent) {
        arrayInfoData.push({
          title: 'ОХ',
          content: oxContent,
        });
      }

      const carsContent = createContentString('машина:', cars, car => `${car?.carMark}, гос. номер: ${car?.gtd}`);
      if (carsContent) {
        arrayInfoData.push({
          title: 'Автомобили',
          content: carsContent,
        });
      }

      const ordersContent = createContentString(
        '',
        recentOrders,
        order => `Номер заказа: ${order?.orderNumber}, статус: ${orderStatusMap[order.orderStatus] || ''}, дата: ${order?.orderDate}`,
      );
      if (ordersContent) {
        arrayInfoData.push({
          title: 'Заказы',
          content: ordersContent,
        });
      }

      window.jivo_api.setCustomData([
        {
          title: 'Номер дисконтной карты',
          content: `номер карты: ${card?.cardNum || ''}`,
        },
        ...arrayInfoData,
      ]);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    handlerSendUserData,
  };
};
